export const initShapeSection = [
    {
        "id": "carre-simple",
        "type": "shape-element",
        "class": "carre-element shape-element",
        "style": {
            "color": "black",
            "border-radius": "0"
        },
        "x": 500,
        "y": 500,
        "isLock": false,
        "src" : "/images/icone-shape/carre.svg",
        "width" : "100px",
        "height" : "100px"
    },
    {
        "id": "carre-bordure-plein",
        "type": "shape-element",
        "class": "carre-element-bordure shape-element",
        "style": {
            "color": "white",
            "border-color":"black",
            "border-width" : "10px",
            "border-style" : "solid",
            "border-radius": "0",
        },
        "x": 500,
        "y": 500,
        "isLock": false,
        "src" : "/images/icone-shape/carre-bordure-plein.svg",
        "width" : "100px",
        "height" : "100px"
    },
    {
        "id": "carre-bordure-vide",
        "type": "shape-element",
        "class": "carre-element-bordure shape-element",
        "style": {
            "color": "#ffffff00",
            "border-color":"black",
            "border-width" : "10px",
            "border-style" : "solid",
            "border-radius": "0"
        },
        "x": 500,
        "y": 500,
        "isLock": false,
        "src" : "/images/icone-shape/carre-bordure-vide.svg",
        "width" : "100px",
        "height" : "100px"
    },
    {
        "id": "rond-simple",
        "type": "shape-element",
        "class": "rond-element shape-element",
        "style": {
            "color": "black",
            "border-radius": "50%"
        },
        "x": 500,
        "y": 500,
        "isLock": false,
        "src" : "/images/icone-shape/rond.svg",
        "width" : "100px",
        "height" : "100px"
    },
    {
        "id": "rond-bordure-plein",
        "type": "shape-element",
        "class": "rond-element-bordure shape-element",
        "style": {
            "color": "white",
            "border-color":"black",
            "border-width" : "10px",
            "border-style" : "solid",
            "border-radius": "50%"
        },
        "x": 500,
        "y": 500,
        "isLock": false,
        "src" : "/images/icone-shape/rond-bordure-plein.svg",
        "width" : "100px",
        "height" : "100px"
    },
    {
        "id": "rond-bordure-vide",
        "type": "shape-element",
        "class": "rond-element-bordure shape-element",
        "style": {
            "color": "#ffffff00",
            "border-color":"black",
            "border-width" : "10px",
            "border-style" : "solid",
            "border-radius": "50%"
        },
        "x": 500,
        "y": 500,
        "isLock": false,
        "src" : "/images/icone-shape/rond-bordure-vide.svg",
        "width" : "100px",
        "height" : "100px"
    }


]